import axios, { AxiosInstance, AxiosError } from 'axios';
import { env } from '@config/environment';
import pb from './pocketbase';

// Create axios instance
const http: AxiosInstance = axios.create({
  baseURL: env.pocketbaseUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add auth token
http.interceptors.request.use(
  (config) => {
    if (pb.authStore.token) {
      config.headers.Authorization = pb.authStore.token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors
http.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Unauthorized - clear auth and redirect to login
      pb.authStore.clear();
      // Kiểm tra đường dẫn hiện tại để quyết định redirect đến đâu
      // Nếu đang ở route admin (/admin/*) thì redirect đến admin login
      // Nếu không thì redirect đến public login
      const isAdminRoute = window.location.pathname.startsWith('/admin/');
      const loginRoute = isAdminRoute ? '/admin/login' : '/login';
      window.location.href = loginRoute;
    }
    return Promise.reject(error);
  }
);

export default http;

